import CatalogsService from '@/services/CatalogsService'
import { User, UserCatalogFilters } from '@/types/Catalogs'
import { PageRequest } from '@/types/Support'
const LIST_USER = 'listUsers'
export async function getListUsers (pageRequest: PageRequest<UserCatalogFilters>): Promise<Array<string>> {
  const listUser = localStorage.getItem(LIST_USER)
  return !listUser ? reloadListUser(pageRequest) : listUser.split(',')
}
async function reloadListUser (pageRequest: PageRequest<UserCatalogFilters>): Promise<Array<string>> {
  const listUser = await getAllUsers(pageRequest)
  localStorage.setItem(LIST_USER, listUser.join(','))
  return listUser
}
function clearListUsers () {
  localStorage.removeItem(LIST_USER)
}
async function getAllUsers (pageRequest: PageRequest<UserCatalogFilters>) {
  const listUser: Array<string> = []
  let response
  do {
    response = (await CatalogsService.getUsers(pageRequest))
    pageRequest.page++
    listUser.push(...response.results.map(user => user.name))
  } while (listUser.length < response.total)
  return listUser
}
const localStorageUser = {
  getListUsers,
  clearListUsers,
  reloadListUser
}
export default localStorageUser
